import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-live-date-time',
  templateUrl: './live-date-time.component.html',
  styleUrls: ['./live-date-time.component.css'],
})
export class LiveDateTimeComponent implements OnChanges {
  constructor() {}

  ngOnChanges(
    changes: SimpleChanges
  ): void {
    if (
      changes &&
      changes['DateTime'] &&
      changes['DateTime'].currentValue !== undefined
    ) {
      const newData = changes['DateTime'].currentValue;

      if (newData != null) {
        this.dateTimeLoop();
      }
    }
  }

  @Input() DateTime?: string;

  public date = new Date();
  public time = '';

  private dateTimeLoop() {
    if (this.DateTime == null) {
      return;
    }

    this.date = new Date(this.DateTime);
    this.time = this.date.toLocaleTimeString();

    setInterval(() => {
      try {
        this.date.setSeconds(this.date.getSeconds() + 1);
        this.time = this.date.toLocaleTimeString();
      } catch (error) {}
    }, 1000);
  }
}
